// extracted by mini-css-extract-plugin
export default {"dialogContent":"TriageAgentDialog-module__dialogContent--JtRfX","comingSoonText":"TriageAgentDialog-module__comingSoonText--OCk8y"};